const getProfileImage = (imageNumber: number) =>
  `https://cdn.si-hallmark.com/matchingmoments/profileimages/image-${imageNumber}.png`;

export default getProfileImage;
